module.exports = __webpack_public_path__ + "static/img/posibleFondo.981bba76.jpg";